import { Button } from "@mui/material";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "./Constants";
import React, {  } from 'react';

// Reusable Button Component
export const ActionButton = ({ onClick, icon, label, disabled }) => {
    return (
      <div>
        <Button
          variant="contained"
          size="medium"
          onClick={onClick}
          disabled={disabled}
          sx={{
            flex: 1,
            minWidth: '120px',
            backgroundColor: PRIMARY_COLOR,
            fontSize: 12,
            '&:hover': { backgroundColor: SECONDARY_COLOR },
            '&:disabled': { opacity: 0.6 },
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            '&:hover': { transform: 'scale(1.05)', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)' },
            '&:active': { transform: 'scale(0.95)' },
          }}
        >
          {icon}
          {label}
        </Button>
      </div>
    );
  };